import { Dispatch } from './NewFeaturesContext'
import { ActionType } from './NewFeaturesContext.actions'
import { INewFeatureItem } from '../../components/ClinNewFeatureTooltip/ClinNewFeatureTooltip.types'
import { getUserNewFeatures } from '../../services/ApiService'
import { filterNewFeatures } from '../../services/NewFeaturesService'

/**
 * A collection of async helper functions for the new features context
 * Each one accepted the dispatch and deals with dispatching its own events once
 * promise calls have been resolved
 */

/**
 * Async API calls need to await and dispatch their own updates
 * @param dispatch
 */
async function getNewFeaturesAsync(dispatch: Dispatch) {
  let newFeatures: INewFeatureItem[] = []
  try {
    await getUserNewFeatures().then((response) => {
      newFeatures = filterNewFeatures(response.data)
    })

    newFeatures.length &&
      dispatch({
        type: ActionType.SetNewFeatures,
        features: newFeatures
      })
  } catch (error) {
    console.warn(error)
  }
}

export { getNewFeaturesAsync }
